import type { Theme } from "@/hooks/use-theme";

/**
 * The browser and system UI colour around the app (status bar of the installed app, Safari's
 * tab bar, Android's task switcher): the page background of each theme, as hex because not every
 * browser reads oklch here. Keep in sync with --background in styles.css and index.html.
 */
export const THEME_COLORS: Record<Theme, string> = { light: "#fbfaf8", dark: "#0b0a09" };

/**
 * Points `theme-color` and `color-scheme` at the app's own theme. A media query on the meta tag
 * would follow the phone's setting instead, so an app switched to dark kept a light status bar.
 */
export function applyThemeColor(theme: Theme, doc: Document = document) {
  let meta = doc.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = doc.createElement("meta");
    meta.name = "theme-color";
    doc.head.append(meta);
  }
  meta.content = THEME_COLORS[theme];
  doc.documentElement.style.colorScheme = theme;
}
